<template>
    <p :class="textClass">
        <span v-if="showNoMoreInvoices">
            Er worden geen verdere facturen meer aangemaakt voor dit contract.
        </span>
        <span v-else-if="showNextInvoiceDate">
            De volgende factuur wordt aangemaakt op {{ moment(nextInvoiceDate).format('DD-MM-YYYY') }}.
        </span>
        <span v-else-if="showNextInvoiceTonight">
            De volgende factuur wordt vannacht aangemaakt.
        </span>
    </p>
</template>

<script>
export default {
    name: 'NextInvoiceStatusMessage',

    props: {
        contract: {
            type: Object,
            default: null
        },
        hasMoreInvoices: {
            type: Boolean,
            default: true
        },
        textClass: {
            type: String,
            default: 'subtle-text'
        }
    },

    computed: {
        endDate() {
            // Contract can be passed directly (InvoicesRecord) or as step1 object (ContractsRecordView)
            return this.contract?.end_date || null
        },

        nextInvoiceDate() {
            // Contract can be passed directly (InvoicesRecord) or as step1 object (ContractsRecordView)
            return this.contract?.next_invoice_date || null
        },

        isNextInvoiceDateToday() {
            if (!this.nextInvoiceDate) {
                return false
            }
            const nextInvoiceDate = moment(this.nextInvoiceDate).startOf('day')
            const today = moment().startOf('day')
            return nextInvoiceDate.isSame(today)
        },

        showNoMoreInvoices() {
            return this.contract &&
                   !_.isNull(this.endDate) &&
                   this.hasMoreInvoices === false
        },

        showNextInvoiceDate() {
            return this.contract &&
                   this.nextInvoiceDate &&
                   !this.isNextInvoiceDateToday &&
                   !this.showNoMoreInvoices
        },

        showNextInvoiceTonight() {
            return this.contract &&
                   this.nextInvoiceDate &&
                   this.isNextInvoiceDateToday &&
                   !this.showNoMoreInvoices
        }
    }
}
</script>

<style scoped>
.subtle-text {
    text-align: center;
    color: #a2a2a2;
    margin-top: 10px;
}
</style>

